import { render } from "./ReserveUpload.vue?vue&type=template&id=bcca665e&scoped=true"
import script from "./ReserveUpload.vue?vue&type=script&lang=js"
export * from "./ReserveUpload.vue?vue&type=script&lang=js"

import "./ReserveUpload.vue?vue&type=style&index=0&id=bcca665e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcca665e"]])

export default __exports__